export default __webpack_public_path__ + "static/media/SKONE.38567231.png";